import wedding from "./photo/wedding.jpg";
import beauty from "./photo/beauty.jpg";
import fashion from "./photo/fashion.jpg";
import birthday from "./photo/birthday.jpg";
import corporate from "./photo/corporate.jpg";
import commercial from "./photo/commercial.jpg";
import nature from "./photo/nature.jpg";
import travel from "./photo/travel.jpg";

const tileData = [
  {
    img: wedding,
    title: "Wedding",
    author: "jill111",
  },
  {
    img: beauty,
    title: "Beauty",
    author: "director90",
  },
  {
    img: fashion,
    title: "Fashion + Modelling",
    author: "Danson67",
  },
  {
    img: birthday,
    title: "Birthday's",
    author: "fancycrave1",
    featured: true,
  },
  {
    img: corporate,
    title: "Corporate Events",
    author: "Hans",
  },
  {
    img: commercial,
    title: "Commercial Product",
    author: "fancycravel",
  },
  {
    img: nature,
    title: "Nature",
    author: "jill111",
    cols: 2,
  },
  {
    img: travel,
    title: "Travel",
    author: "BkrmadtyaKarki",
  },
];

export default tileData;
